import SihirDefteriPrivacy from "pages/LandingPages/SihirDefteri/Privacy";

export default SihirDefteriPrivacy;
